import Vue from 'vue';
import Vuex from 'vuex';

import AuthModule from "./modules/auth.module"
import UsersModule from "./modules/users.module"
import ScheduleModule from "./modules/schedule.module";
import HistoryModule from "./modules/history.module";
import AirportModule from "./modules/airport.module";
import AircraftsModule from "./modules/aircrafts.module";
import FlightsModule from "./modules/flights.module";
import PermissionsModule from "./modules/permissions.module";
import RolesModule from "./modules/roles.module";
import WeatherMatrix from "./modules/weathermatrix.module";
import FIRsModule from "./modules/firs.module";

import IpadMain from "./modules/IpadPreview/ipadmain.module";
import FlightPlanning from "./modules/IpadPreview/BeforeTake-off/flightplanning.module";
import Notams from "./modules/IpadPreview/BeforeTake-off/FlightPlanning/notams.module";
import ShortAtc from "./modules/IpadPreview/BeforeTake-off/FlightPlanning/shortatc.module";
import AdditionalDocuments  from "./modules/IpadPreview/BeforeTake-off/FlightPlanning/additionaldocuments.module";
import DEP from "./modules/IpadPreview/BeforeTake-off/WXandNotams/DEP.module";
import SelectedNotams from "./modules/IpadPreview/BeforeTake-off/WXandNotams/selectednotams.module";
import PostFlightReporting  from "./modules/IpadPreview/AfterLanding/postflightreporting.module";

import EFB from "./modules/efb.module";

// import PreFlightReporting from "./modules/IpadPreview/BeforeTake-off/preflightreporting.module";

import ViewandSign from "./modules/IpadPreview/BeforeTake-off/viewandsign.module";
import OverView  from "./modules/IpadPreview/Flight/overview.module";

import AppHeader from "./modules/AppHeader.module";

import NotifyModule from "./modules/notifies.module";

import IpadUserModule from "./modules/ipadusers.module";

import ReportSummaryModule from "./modules/reportsummary.module";
import ArchiveSummaryModule from "./modules/archivesummary.module";


Vue.use(Vuex);
const store = new Vuex.Store();

store.registerModule("auth", AuthModule);
store.registerModule("users", UsersModule);
store.registerModule("schedule", ScheduleModule);
store.registerModule("history", HistoryModule);
store.registerModule("airport", AirportModule);
store.registerModule("aircrafts", AircraftsModule);
store.registerModule("flights", FlightsModule);
store.registerModule("permissions", PermissionsModule);
store.registerModule("roles", RolesModule);
store.registerModule("weathermatrix", WeatherMatrix);
store.registerModule("firs", FIRsModule);

store.registerModule("ipadmain", IpadMain);
store.registerModule("flightplanning", FlightPlanning);
store.registerModule("notams", Notams);
store.registerModule("shortatc",ShortAtc);
store.registerModule("additionaldocuments",AdditionalDocuments);
store.registerModule("dep",DEP);
store.registerModule("selectednotams",SelectedNotams);
store.registerModule("postflightreporting",PostFlightReporting);
store.registerModule("viewandsign",ViewandSign);

store.registerModule("overview",OverView);

store.registerModule("appheader",AppHeader);

store.registerModule("notifies",NotifyModule);

store.registerModule("ipadusers",IpadUserModule);

store.registerModule("efb",EFB);

store.registerModule("reportsummary",ReportSummaryModule);
store.registerModule("archivesummary",ArchiveSummaryModule);
export default store
